"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getName = exports.getAddress = void 0;
const monocle = require("monocle-ts");
exports.getAddress = new monocle.Getter((user) => user.addressDetails
    ? `${user.addressDetails.street}, ${user.addressDetails.postalCode} ${user.addressDetails.city}`
    : '');
exports.getName = new monocle.Getter((user) => (user ? `${user.firstName} ${user.lastName}` : '--'));
//# sourceMappingURL=userLens.js.map